var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Content',{scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('Form',{attrs:{"scheme":_vm.scheme,"method-fetch-data":_vm.methods.fetchData,"method-create-data":_vm.methods.createData,"method-update-data-idempotent":_vm.methods.updateData,"redirect-to-edit":"/users/edit"}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }